import {registerBlockType} from '@wordpress/blocks';
import {__} from '@wordpress/i18n';
import Edit from "./edit";
import Save from "./save";

registerBlockType("plm/slide-v2",{
    
    $schema: "https://schemas.wp.org/trunk/block.json",
    title: __("slide"),
    description: __('single slider content'),
    icon: "ellipsis",
    parent:['plm/slider-v2'],
    attributes:{
        blockId: {
            type: "string"
        },
        schedule_program:{
            type:"boolean",
            default:false
        },
        schedule_init:{
            type:"string"
        },
        schedule_end:{
            type:"string"
        },
        showSlide:{
            type:"boolean",
            default:true
        }
    },
    supports: {
		anchor: true,
		align: true,
		alignWide: true,
        className: true,
    },
    edit: Edit,
    save: Save
})